import { BASE_URL, JWT_APP_ID } from '../../config/URL'
import axios from 'axios'
import { generateDeviceInfo } from '../../utils'
import trackGa from '../../analytics'

const accountUrl = `${BASE_URL}/user/v1.0/accounts`
const accountUrlVOneOne = `${BASE_URL}/user/v1.1/accounts`
const loginUrl = `${BASE_URL}/user/v1.0/sessions`
const loginUrlVOneOne = `${BASE_URL}/user/v1.1/sessions`
const otpUrl = `${BASE_URL}/user/v1.0/sessions/otp`
const refreshUrl = `${BASE_URL}/user/v1.1/sessions/refresh`
const forgotPassUrl = `${BASE_URL}/user/v1.0/passwords/forget`
const resetPassUrl = `${BASE_URL}/user/v1.0/passwords/reset`
const verifyUrl = `${BASE_URL}/user/v1.0/accounts/verify`

const emailTester = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)

export function getAuthInfo() {
  return (dispatch, getState) => {
    const token = localStorage.getItem('gfToken')
    let user = null
    let refreshToken = null

    if (token) {
      try {
        user = JSON.parse(localStorage.getItem('gfUser'))
        refreshToken = localStorage.getItem('gfRefreshToken')
      } catch (err) {
        console.log(err)
      }
    }

    if (token && refreshToken && user) {
      dispatch(setToken(token, refreshToken))
      dispatch(setUser(user))
      dispatch(getAccountInfo())
    }
  }
}

export function getAccountInfo() {
  return async (dispatch, getState) => {
    const state = getState()
    const token = state.auth.token

    try {
      dispatch({
        type: 'GET_ACCOUNT_INFO'
      })
      const res = await axios.get(accountUrlVOneOne, {
        headers: {
          Authorization: token
        }
      })

      dispatch({
        type: 'GET_ACCOUNT_INFO_SUCCESS',
        data: res.data.data.account
      })
    } catch (err) {
      if (err.response && err.response.data) {
        dispatch({
          type: 'GET_ACCOUNT_INFO_FAILURE',
          err: err.response.data.error.message
        })
      }
    }
  }
}

function setUser(user) {
  return dispatch => {
    dispatch({
      type: 'SET_USER',
      user
    })
  }
}

export function setToken(token, refreshToken) {
  return dispatch => {
    dispatch({
      type: 'SET_TOKEN',
      token,
      refreshToken
    })
  }
}

export function registerByEmail(name, email, password) {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: 'REGISTER_USER'
      })
      const res = await axios.post(
        accountUrl,
        {
          email: emailTester.test(email) ? email.toLowerCase() : email,
          password,
          name
        },
        {
          headers: {
            'Cloudfront-JWT-AppId': JWT_APP_ID
          }
        }
      )

      trackGa('Auth', 'completeRegisterByEmail', {
        userID: res.data.data.userId
      })
      dispatch({
        type: 'REGISTER_USER_SUCCESS'
      })
      dispatch(loginByEmail(email, password))
    } catch (err) {
      let errorMessage = 'General error, please try again later'
      if (err.response && err.response.data) {
        const { error } = err.response.data
        errorMessage = error.details[0] || error.message
        if (error.code === 'gfx4000003') {
          errorMessage = 'Password should be at least 8 characters'
        }
        if (error.code === 'gfu4000202') {
          errorMessage = 'Email has existed, please use another email'
        }
      }

      dispatch({
        type: 'REGISTER_USER_FAILURE',
        err: errorMessage
      })
    }
  }
}

export function logout() {
  return (dispatch, getState) => {
    const state = getState()
    const token = state.auth.token
    const userID = state.auth.user.account.userId

    if (!token) {
      return null
    }
    trackGa('Auth', 'logOut', {
      time: new Date().getTime(),
      userID
    })
    dispatch({ type: 'LOGOUT' })

    axios.delete(loginUrl, {
      headers: {
        Authorization: token
      }
    })

    return window.location.reload()
  }
}

export function loginByEmail(email, password) {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: 'LOGIN'
      })

      const res = await axios.post(
        loginUrlVOneOne,
        {
          type: 'username',
          username: emailTester.test(email) ? email.toLowerCase() : email,
          password,
          device: generateDeviceInfo()
        },
        {
          headers: {
            'Cloudfront-JWT-AppId': JWT_APP_ID
          }
        }
      )

      trackGa('Auth', 'completeLogInByEmail', {
        time: new Date().getTime(),
        userID: res.data.data.account.userId
      })
      dispatch({
        type: 'LOGIN_SUCCESS',
        data: res.data.data
      })
      dispatch(getAccountInfo())
    } catch (err) {
      const code = err.response ? err.response.data.error.code : err
      let mes = ''

      if (code === 'gfu4000201' || code === 'gfx4000003') {
        mes = 'Invalid Credentials'
      } else {
        mes = err.response
          ? err.response.data.error.message
          : 'General Login Error'
      }

      dispatch({
        type: 'LOGIN_FAILURE',
        err: mes
      })
      throw err
    }
  }
}

export function forgotPassword(email) {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: 'FORGOT_PASSWORD'
      })
      await axios.post(
        forgotPassUrl,
        {
          email
        },
        {
          headers: {
            'Cloudfront-JWT-AppId': JWT_APP_ID
          }
        }
      )

      dispatch({
        type: 'FORGOT_PASSWORD_SUCCESS'
      })
    } catch (err) {
      dispatch({
        type: 'FORGOT_PASSWORD_FAILURE',
        err: err.response.data.error.message
      })
    }
  }
}

export function resetPassword(password, token) {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: 'RESET_PASSWORD'
      })
      await axios.post(
        resetPassUrl,
        {
          password,
          token
        },
        {
          headers: {
            'Cloudfront-JWT-AppId': JWT_APP_ID
          }
        }
      )

      dispatch({
        type: 'RESET_PASSWORD_SUCCESS'
      })
    } catch (err) {
      dispatch({
        type: 'RESET_PASSWORD_FAILURE',
        err: err.response.data.error.message
      })
    }
  }
}

export const getRefreshToken = () => async (dispatch, getState) => {
  const state = getState()
  const token = state.auth.token
  const refreshToken = state.auth.refreshToken
  const res = await fetch(refreshUrl, {
    method: 'POST',
    headers: {
      authorization: refreshToken,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      accessToken: token,
      device: generateDeviceInfo()
    })
  })
  const data = await res.json()
  console.log('data', data)

  if (data.error) throw data

  dispatch(setToken(data.data.accessToken, data.data.refreshToken))
  dispatch(getAccountInfo())

  return data
}

export const resetAuthState = () => (dispatch, getState) => {
  return dispatch({
    type: 'RESET_AUTH_STATE'
  })
}

export function signinWithGoogle() {
  return async dispatch => {
    try {
      dispatch({
        type: 'LOGIN'
      })
      await window.gapi.auth2
        .getAuthInstance()
        .signIn({ scope: 'profile email', prompt: 'select_account' })

      const googleUser = window.gapi.auth2.getAuthInstance().currentUser.get()
      const ggToken = googleUser.getAuthResponse().id_token

      const res = await axios.post(
        loginUrlVOneOne,
        {
          type: 'google',
          token: ggToken,
          device: generateDeviceInfo()
        },
        {
          headers: {
            'Cloudfront-JWT-AppId': JWT_APP_ID
          }
        }
      )

      trackGa('Auth', 'completeLogInByGoogle', {
        time: new Date().getTime(),
        userID: res.data.data.account.userId
      })
      dispatch({
        type: 'LOGIN_SUCCESS',
        data: res.data.data
      })
      dispatch(getAccountInfo())
    } catch (err) {
      const code = err.response
        ? err.response.data.error.code
        : 'Error! Try again later!'
      let mes = ''

      if (code === 'gfu4000201' || code === 'gfx4000003') {
        mes = 'Invalid Credentials'
      } else {
        mes = err.response ? err.response.data.error.message : err.error
      }

      dispatch({
        type: 'LOGIN_FAILURE',
        err: mes
      })
      throw err
    }
  }
}

const getFBToken = () => {
  return new Promise((resolve, reject) => {
    window.FB.login(
      res => {
        if (res.status !== 'connected') {
          reject(res)
        } else resolve(res.authResponse)
      },
      { scope: 'email,public_profile', auth_type: 'rerequest' }
    )
  })
}

export function signinWithFB() {
  return async dispatch => {
    try {
      dispatch({
        type: 'LOGIN'
      })
      const auth = await getFBToken()

      const res = await axios.post(
        loginUrlVOneOne,
        {
          type: 'facebook',
          token: auth.accessToken,
          device: generateDeviceInfo()
        },
        {
          headers: {
            'Cloudfront-JWT-AppId': JWT_APP_ID
          }
        }
      )

      trackGa('Auth', 'completeLogInByFacebook', {
        time: new Date().getTime(),
        userID: res.data.data.account.userId
      })
      dispatch({
        type: 'LOGIN_SUCCESS',
        data: res.data.data
      })
      dispatch(getAccountInfo())
    } catch (err) {
      const code = err.response && err.response.data.error.code
      let mes = ''

      if (code === 'gfu4000201' || code === 'gfx4000003') {
        mes = 'Invalid Credentials'
      } else {
        mes = err.response
          ? err.response.data.error.message
          : 'General Facebook Login Error'
      }

      dispatch({
        type: 'LOGIN_FAILURE',
        err: mes
      })
      throw err
    }
  }
}

export const requestOtp = phone => {
  return axios.post(
    otpUrl,
    { mobile: phone },
    {
      headers: { 'Cloudfront-JWT-AppId': JWT_APP_ID }
    }
  )
}

export const verifyEmail = token => {
  return axios.post(
    verifyUrl,
    {
      token
    },
    {
      headers: { 'Cloudfront-JWT-AppId': JWT_APP_ID }
    }
  )
}

export function loginByPhone(phone, otp) {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: 'LOGIN'
      })

      const res = await axios.post(
        loginUrlVOneOne,
        {
          type: 'mobile',
          username: phone,
          otp,
          device: generateDeviceInfo()
        },
        {
          headers: {
            'Cloudfront-JWT-AppId': JWT_APP_ID
          }
        }
      )

      trackGa('Auth', 'completeLogInByPhone', {
        time: new Date().getTime(),
        userID: res.data.data.account.userId
      })
      dispatch({
        type: 'LOGIN_SUCCESS',
        data: res.data.data
      })
      dispatch(getAccountInfo())
    } catch (err) {
      const code = err.response ? err.response.data.error.code : err
      let mes = ''

      if (code === 'gfu4000201' || code === 'gfx4000003') {
        mes = 'Invalid Credentials'
      } else {
        mes = err.response
          ? err.response.data.error.message
          : 'General Login Error'
      }

      dispatch({
        type: 'LOGIN_FAILURE',
        err: mes
      })
      throw err
    }
  }
}
